export default "__VITE_ASSET__8c242fc0__"